/* ============================================================
   SUMMIT — HUB BUILDER
   ------------------------------------------------------------
   Behaviour for sections/hub-builder-v2.liquid. Config arrives
   as JSON in <script type="application/json" data-hub-data=UID>.

   WHICH TAB OPENS, highest priority first:
     1. #grill-station / #link / #outpost in the URL
     2. the line a ?add= part belongs to
     3. the page you are standing on (see LINE_BY_PATH)
     4. whatever the customer last had open this session
     5. the section's own default

   PLACEMENT (placeItem is the ONLY door into `sel`):
     - already selected + no side requested -> leave it alone
     - explicit both sides -> only if both are genuinely free
     - otherwise: requested side, then LEFT, then RIGHT
     - nothing free -> refuse and name the occupant of EVERY
       position so the customer can choose what to drop

   THE SETUP-LINE TABS MUST NEVER DISAPPEAR. See the sticky
   measurement block below — the rule is that nothing measures
   or writes layout while the customer is scrolling.
   ============================================================ */
(function(){
  "use strict";

  var BUILD_KEY = "summit-hub";
  var STORE_KEY = "summit:hub-build";

  /* Page path -> setup line. Handles are historical and do not match
     the line names (LINK lives at /pages/course-attachments), so this
     cannot be inferred and has to be stated. */
  var LINE_BY_PATH = [
    ["/pages/grill-station",      "grill-station"],
    ["/pages/course-attachments", "link"],
    ["/pages/outpost",            "outpost"]
  ];

  function boot(root){
    if (!root || root.dataset.booted) return;
    root.dataset.booted = "1";

    var uid = root.dataset.uid;
    var node = document.querySelector('[data-hub-data="' + uid + '"]');
    if (!node) return;

    var DATA;
    try { DATA = JSON.parse(node.textContent); } catch(e){ return; }

    var T = DATA.text || {};
    var MIRROR_AXIS = (DATA.mirrorAxis || 0) * 0.1;
    var HUB_IDS = {};
    (DATA.hubVariantIds || []).forEach(function(id){ HUB_IDS[id] = 1; });

    var $  = function(s,c){ return (c||root).querySelector(s); };
    var $$ = function(s,c){ return Array.prototype.slice.call((c||root).querySelectorAll(s)); };
    function el(t,c,h){ var e=document.createElement(t); if(c)e.className=c; if(h!=null)e.innerHTML=h; return e; }
    function esc(s){ return String(s).replace(/[&<>"]/g, function(m){
      return ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"})[m]; }); }
    function money(cents){
      var n = cents/100;
      return "$" + (n % 1 === 0 ? n.toLocaleString("en-US")
        : n.toLocaleString("en-US",{minimumFractionDigits:2,maximumFractionDigits:2}));
    }
    function hasLine(key){ return DATA.lines.some(function(l){ return l.key === key; }); }
    function lineFromPath(){
      var p = (window.location.pathname || "").toLowerCase();
      for (var i=0;i<LINE_BY_PATH.length;i++){
        if (p.indexOf(LINE_BY_PATH[i][0]) === 0 && hasLine(LINE_BY_PATH[i][1])) return LINE_BY_PATH[i][1];
      }
      return null;
    }

    /* Send "browse all attachments" to the matching group in the
       catalogue. The directory's block ids are the line keys, so the
       fragment is just g-<line>. Recomputed on every render so it
       always points at the tab currently on screen. */
    function syncBrowseLink(){
      var a = $(".hb-browse");
      if (!a) return;
      if (!a.dataset.base) a.dataset.base = (a.getAttribute("href") || "").split("#")[0];
      if (!a.dataset.base) return;
      a.setAttribute("href", a.dataset.base + "#g-" + line);
    }

    /* ================================================================
       STICKY MEASUREMENT  —  read this before changing anything here
       ================================================================
       --hb-top is how much fixed/sticky furniture the theme parks at
       the top of the viewport. The setup-line tab bar sticks directly
       underneath it. Two rules, both learned from the same bug:

       1. MEASURE INTENT, NOT POSITION.
          For each candidate we take its CSS `top` plus its height, and
          also its current bottom edge, and keep the larger. CSS top +
          height is a layout fact that holds at any scroll offset; a
          bounding rect is only true for the instant it was read. The
          old code additionally required `top < 4px`, which silently
          threw away the page nav — that bar sticks BELOW the header at
          top:90px, so it was never counted, and the tabs were being
          told to stick 60px too high.

       2. NEVER MEASURE DURING SCROLL.
          The old code re-measured 150ms after scrolling stopped. That
          one call was the whole glitch. --hb-top feeds three things at
          once: the tab bar's sticky offset, the stage column's sticky
          offset, and the stage's own width. So a single bad reading
          dropped the tabs behind the header AND jumped the drawing a
          size AND changed the section's height — which changed the
          bounding box that the shrink toggle reads, which resized the
          drawing again. A measurement feeding a layout feeding the
          same measurement, resolving about 200ms later.

          Nothing the theme puts at the top of the viewport changes
          height as a function of scroll, so measuring on scroll bought
          nothing and cost us the bug. We now measure on load, on
          resize, and when an observed element actually changes size.
          While the customer scrolls, no layout value is written.
    */
    var topOffset = 0;
    var tabHeight = 0;

    function rawTop(){
      var max = 0;
      var nodes = document.querySelectorAll(
        "body > *, body > * > *, body > * > * > *, body > * > * > * > *");
      Array.prototype.slice.call(nodes, 0, 600).forEach(function(n){
        if (!n.getBoundingClientRect) return;
        if (n === root || root.contains(n) || n.contains(root)) return;

        var cs = getComputedStyle(n);
        if (cs.position !== "fixed" && cs.position !== "sticky") return;
        if (cs.display === "none" || cs.visibility === "hidden") return;
        if (parseFloat(cs.opacity || "1") < 0.05) return;

        var h = n.offsetHeight;
        var w = n.offsetWidth;
        if (h < 8 || h > 220) return;
        if (w < window.innerWidth * 0.6) return;

        /* intent: where it has been told to park, plus how tall it is */
        var cssTop = parseFloat(cs.top);
        if (!isNaN(cssTop) && cssTop >= 0 && cssTop <= 300) max = Math.max(max, cssTop + h);

        /* position: only trusted because we are not mid-scroll */
        var r = n.getBoundingClientRect();
        if (r.top >= -2 && r.top <= 200 && r.bottom > 0) max = Math.max(max, r.bottom);
      });
      return Math.max(0, max);
    }

    function measureTop(){
      var v = Math.round(rawTop());
      if (v === topOffset) return;
      topOffset = v;
      root.style.setProperty("--hb-top", v + "px");
    }

    /* offsetHeight reads 0 between layout passes, and a zero here would
       collapse the stage sizing maths. Ignore those. */
    function measureTabs(){
      var bar = $("[data-tabbar]");
      if (!bar) return;
      var h = Math.round(bar.offsetHeight);
      if (h <= 0 || h === tabHeight) return;
      tabHeight = h;
      root.style.setProperty("--hb-tabh", h + "px");
    }
    function measureAll(){ measureTop(); measureTabs(); }

    var line = DATA.defaultLine || (DATA.lines[0] && DATA.lines[0].key);
    var hubMode = "yes", hubVariant = "", busy = false;
    var sel = {};
    var variantChoice = {};
    var flashIds = {};

    var MOUNT = {
      side_upper:      { sides:true,  a:"Left",  b:"Right", cellsA:["RAIL-L-U"], cellsB:["RAIL-R-U"] },
      side_lower:      { sides:true,  a:"Left",  b:"Right", cellsA:["RAIL-L-D"], cellsB:["RAIL-R-D"] },
      side:            { sides:true,  a:"Left",  b:"Right", cellsA:["RAIL-L-D"], cellsB:["RAIL-R-D"] },
      rear_upper_half: { sides:true,  a:"Left",  b:"Right", cellsA:["U-L"], cellsB:["U-R"] },
      rear_lower_half: { sides:true,  a:"Left",  b:"Right", cellsA:["L-L"], cellsB:["L-R"] },
      rear_tall_half:  { sides:true,  a:"Left",  b:"Right", cellsA:["U-L","L-L"], cellsB:["U-R","L-R"] },
      rear_full_row:   { sides:true,  a:"Lower", b:"Upper", cellsA:["L-L","L-R"], cellsB:["U-L","U-R"] },
      rear_lower_full: { sides:false, a:"Lower", b:null,    cellsA:["L-L","L-R"], cellsB:[] },
      under:           { sides:false, a:"Under", b:null,    cellsA:["UNDER"], cellsB:[] }
    };
    var CELL_NAME = {
      "U-L":"left rear upper spot", "U-R":"right rear upper spot",
      "L-L":"left rear lower spot", "L-R":"right rear lower spot", "UNDER":"bin slot",
      "RAIL-L-U":"left side upper spot", "RAIL-L-D":"left side lower spot",
      "RAIL-R-U":"right side upper spot", "RAIL-R-D":"right side lower spot"
    };
    function mountOf(it){ return MOUNT[it.mount] || MOUNT.side_lower; }
    function mountText(it){
      switch(it.mount){
        case "under": return "Mounts underneath";
        case "rear_lower_full": return "Rear — full lower shelf";
        case "rear_full_row": return "Rear — a full shelf, upper or lower";
        case "rear_tall_half": return "Rear — full height, one side";
        case "rear_upper_half": return "Rear — upper shelf, one side";
        case "rear_lower_half": return "Rear — lower shelf, one side";
        case "side_upper": return "Side rail — upper position";
        default: return "Side rail — lower position";
      }
    }

    function itemById(id){ for (var i=0;i<DATA.items.length;i++) if (DATA.items[i].id===id) return DATA.items[i]; return null; }
    function itemByHandle(h){ for (var i=0;i<DATA.items.length;i++) if (DATA.items[i].handle===h) return DATA.items[i]; return null; }
    function cellsFor(it, side){ var m = mountOf(it); return side === "b" ? m.cellsB : m.cellsA; }

    /* Attachments that really have options carry a `variants` list from Liquid;
       single-variant ones do not and behave exactly as they always have.
       chosenVariant is the ONLY place that decides which variant an attachment
       is currently set to, so the price on the card, the summary total, the
       sold-out state and the line that reaches /cart/add can never disagree. */
    function hasVariants(it){ return !!(it && it.variants && it.variants.length > 1); }
    function chosenVariant(it){
      if (!hasVariants(it)) return { id: it.variantId, title: "", price: it.price, available: it.available };
      var list = it.variants, i;
      for (i=0;i<list.length;i++) if (String(list[i].id) === String(variantChoice[it.id])) return list[i];
      for (i=0;i<list.length;i++) if (String(list[i].id) === String(it.variantId)) return list[i];
      return list[0];
    }

    function occupancy(skipId){
      var cells = { "U-L":null,"U-R":null,"L-L":null,"L-R":null,"UNDER":null,
                    "RAIL-L-U":null,"RAIL-L-D":null,"RAIL-R-U":null,"RAIL-R-D":null };
      Object.keys(sel).forEach(function(id){
        if (id === skipId) return;
        var it = itemById(id); if (!it) return;
        (sel[id].sides || ["a"]).forEach(function(sd){
          cellsFor(it, sd).forEach(function(c){ if (cells[c] === null) cells[c] = it.title; });
        });
      });
      return cells;
    }
    function blockReason(it, side){
      var cells = occupancy(it.id);
      var req = cellsFor(it, side);
      for (var i=0;i<req.length;i++){
        if (cells[req[i]]) return "the " + (CELL_NAME[req[i]] || "that spot") + " is taken by " + cells[req[i]];
      }
      return null;
    }

    function conflictsFor(it){
      var m = mountOf(it);
      var cells = occupancy(it.id);
      return sidesAvailable(it).map(function(sd){
        var names = [];
        cellsFor(it, sd).forEach(function(c){
          if (cells[c] && names.indexOf(cells[c]) === -1) names.push(cells[c]);
        });
        return { label: (sd === "b" ? (m.b || "Right") : (m.a || "Left")), names: names };
      }).filter(function(r){ return r.names.length; });
    }

    function artFor(it, sd){
      if (it.art[sd]) return { src: it.art[sd], flip:false, off: it.offset[sd] || [0,0] };
      if (it.mirror){
        var other = sd === "a" ? "b" : "a";
        if (it.art[other]){
          var o = it.offset[sd] || [0,0];
          return { src: it.art[other], flip:true, off:[o[0],o[1]], axis:(sd === "b" ? MIRROR_AXIS : -MIRROR_AXIS) };
        }
      }
      return null;
    }
    function sidesAvailable(it){
      var m = mountOf(it);
      return (m.sides ? ["a","b"] : ["a"]).filter(function(sd){ return !!artFor(it, sd); });
    }

    /* ---- the only door into `sel` ---------------------------------- */
    function placeItem(it, prefer){
      if (!it || !chosenVariant(it).available) return null;
      var avail = sidesAvailable(it);
      if (!avail.length) return null;

      prefer = (prefer || []).filter(function(sd){ return avail.indexOf(sd) > -1; });
      if (sel[it.id] && !prefer.length) return sel[it.id].sides;

      if (prefer.length > 1 && it.maxQty > 1){
        var bothFree = prefer.every(function(sd){ return !blockReason(it, sd); });
        if (bothFree){ sel[it.id] = { sides: prefer.slice() }; return sel[it.id].sides; }
      }

      var order = [];
      prefer.forEach(function(sd){ if (order.indexOf(sd) === -1) order.push(sd); });
      ["a","b"].forEach(function(sd){
        if (avail.indexOf(sd) > -1 && order.indexOf(sd) === -1) order.push(sd);
      });

      for (var i=0;i<order.length;i++){
        if (!blockReason(it, order[i])){ sel[it.id] = { sides:[order[i]] }; return sel[it.id].sides; }
      }
      return null;
    }

    function applyItems(map){
      var applied = [], failed = [];
      Object.keys(map || {}).forEach(function(h){
        var it = itemByHandle(h);
        if (!it) return;
        if (placeItem(it, map[h] || [])) applied.push(it); else failed.push(it);
      });
      return { applied: applied, failed: failed };
    }

    function showAlert(html){
      var a = $("[data-alert]"), t = $("[data-alerttext]");
      if (!a || !t) return;
      t.innerHTML = html; a.style.display = "flex";
    }
    function hideAlert(){ var a = $("[data-alert]"); if (a) a.style.display = "none"; }

    function noRoomHtml(it){
      var rows = conflictsFor(it);
      var head = "<strong>" + esc(it.title) + " would not fit</strong>";
      if (!rows.length) return head + "There is no free position left for it on this build.";
      if (rows.length === 1){
        return head + "Its only position (" + esc(rows[0].label) + ") is taken by " +
          esc(rows[0].names.join(", ")) + ". Remove that and add this again.";
      }
      var list = rows.map(function(r){
        return '<div style="display:flex;gap:10px;margin-top:4px">' +
               '<span style="opacity:.72;min-width:52px;flex:none">' + esc(r.label) + '</span>' +
               '<span>' + esc(r.names.join(", ")) + '</span></div>';
      }).join("");
      return head + "Every position it can take is occupied. Remove one of these, then add it again:" +
             '<div style="margin-top:6px">' + list + "</div>";
    }

    function readStore(){
      try {
        var raw = sessionStorage.getItem(STORE_KEY);
        if (!raw) return null;
        var s = JSON.parse(raw);
        return (s && typeof s === "object") ? s : null;
      } catch(e){ return null; }
    }
    function writeStore(){
      try {
        var prev = readStore() || {};
        var items = prev.items || {};
        var variants = prev.variants || {};
        DATA.items.forEach(function(it){ delete items[it.handle]; });
        Object.keys(sel).forEach(function(id){
          var it = itemById(id);
          if (it) items[it.handle] = sel[id].sides || ["a"];
        });
        DATA.items.forEach(function(it){
          if (hasVariants(it) && variantChoice[it.id]) variants[it.handle] = String(variantChoice[it.id]);
        });
        sessionStorage.setItem(STORE_KEY, JSON.stringify({
          line: line, hubMode: hubMode, hubVariant: hubVariant, items: items, variants: variants
        }));
      } catch(e){}
    }
    function clearStore(){ try { sessionStorage.removeItem(STORE_KEY); } catch(e){} }

    function visibleItems(){
      var groups = {}, order = [];
      DATA.items.forEach(function(it){
        if (!groups[it.group]) { groups[it.group] = []; order.push(it.group); }
        groups[it.group].push(it);
      });
      var primary = [], cross = [];
      order.forEach(function(g){
        var members = groups[g];
        var mine = members.filter(function(m){ return m.lines && m.lines[line]; })[0];
        if (mine) primary.push(mine); else cross.push(members[0]);
      });
      return { primary: primary, cross: cross };
    }

    function renderLines(){
      $$("[data-lines] button").forEach(function(b){
        b.setAttribute("aria-selected", String(b.dataset.line === line));
      });
    }

    function card(it){
      var s = sel[it.id], isSel = !!s, m = mountOf(it);
      var ch = chosenVariant(it);
      var c = el("div","hb-card" + (isSel ? " sel" : "") + (flashIds[it.id] ? " flash" : ""));
      c.setAttribute("role","button"); c.tabIndex = 0; c.setAttribute("aria-pressed", String(isSel));
      c.dataset.handle = it.handle;
      c.dataset.blockId = it.id;
      c.dataset.variantId = String(ch.id);

      var thumb = it.art.a || it.art.b;
      c.appendChild(el("div","hb-thumb", thumb ? '<img src="'+thumb+'" alt="" loading="lazy">' : ""));

      var body = el("div","hb-body");
      body.appendChild(el("div","hb-name", esc(it.title)));
      body.appendChild(el("div","hb-meta", esc((it.note && it.note.length) ? it.note : mountText(it))));

      var avail = sidesAvailable(it);
      var noRoom = false;
      if (!ch.available){
        c.classList.add("soldout"); c.tabIndex = -1;
        body.appendChild(el("div","hb-why","Currently sold out"));
      } else if (!isSel){
        if (!avail.length){
          c.classList.add("blocked"); c.tabIndex = -1;
          body.appendChild(el("div","hb-why","Drawing coming soon"));
        } else if (avail.every(function(sd){ return !!blockReason(it, sd); })){
          noRoom = true;
          c.classList.add("blocked");
          var txt = conflictsFor(it).map(function(r){
            return r.label + ": " + r.names.join(", ");
          }).join("  ·  ");
          body.appendChild(el("div","hb-why", "No room — " + esc(txt)));
        }
      }
      /* Variant picker — only for attachments with real options. The card is
         itself the toggle, so the picker keeps its own events to itself. */
      if (hasVariants(it)){
        var vwrap = el("div","hb-variant");
        var lid = "hbv-" + uid + "-" + it.id;
        var lab = el("label", null, esc(it.optionName || "Option"));
        lab.setAttribute("for", lid);
        var pick = document.createElement("select");
        pick.id = lid;
        pick.setAttribute("data-variantpicker","");
        it.variants.forEach(function(vr){
          var o = document.createElement("option");
          o.value = String(vr.id);
          o.textContent = vr.title + (vr.available ? "" : " — Sold out");
          o.dataset.price = String(vr.price);
          o.dataset.available = String(!!vr.available);
          o.disabled = !vr.available;
          if (String(vr.id) === String(ch.id)) o.selected = true;
          pick.appendChild(o);
        });
        ["click","mousedown","keydown"].forEach(function(evt){
          vwrap.addEventListener(evt, function(e){ e.stopPropagation(); });
        });
        pick.addEventListener("change", function(e){
          e.stopPropagation();
          variantChoice[it.id] = pick.value;
          /* a sold-out choice cannot stay on the build */
          if (!chosenVariant(it).available) delete sel[it.id];
          renderAll();
          var back = root.querySelector('.hb-card[data-block-id="' +
            String(it.id).replace(/"/g,"") + '"] [data-variantpicker]');
          if (back) back.focus();
        });
        vwrap.appendChild(lab);
        vwrap.appendChild(pick);
        body.appendChild(vwrap);
      }

      c.appendChild(body);

      var act = el("div","hb-actions");
      act.appendChild(el("div","hb-price", money(ch.price)));

      if (m.sides && isSel && avail.length > 1){
        var sw = el("div","hb-sides");
        var opts = [["a", m.a], ["b", m.b]];
        if (it.maxQty > 1) opts.push(["both","Both"]);
        opts.forEach(function(o){
          var want = o[0] === "both" ? ["a","b"] : [o[0]];
          var b = el("button", null, o[1]); b.type = "button";
          var ok = want.every(function(sd){
            return (s.sides||[]).indexOf(sd) > -1 || !blockReason(it, sd);
          });
          b.disabled = !ok;
          var chosen = JSON.stringify(s.sides) === JSON.stringify(want);
          b.setAttribute("aria-pressed", String(chosen));
          if (!ok){
            var why = want.map(function(sd){ return blockReason(it, sd); }).filter(Boolean)[0];
            b.title = why || "Not available";
            b.setAttribute("aria-label", o[1] + " — " + (why || "not available"));
          } else if (!chosen){
            b.title = "Available";
            b.setAttribute("aria-label", o[1] + " — available");
          }
          b.addEventListener("click", function(e){
            e.stopPropagation();
            var keep = sel[it.id];
            delete sel[it.id];
            if (!placeItem(it, want)) sel[it.id] = keep;
            renderAll();
          });
          sw.appendChild(b);
        });
        act.appendChild(sw);
      } else {
        act.appendChild(el("div","hb-tog",'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>'));
      }
      c.appendChild(act);

      function toggle(){
        if (sel[it.id]) { delete sel[it.id]; hideAlert(); renderAll(); return; }
        if (c.classList.contains("soldout")) return;
        if (noRoom){ showAlert(noRoomHtml(it)); return; }
        if (c.classList.contains("blocked")) return;
        if (!placeItem(it, [])) { showAlert(noRoomHtml(it)); return; }
        hideAlert(); renderAll();
      }
      c.addEventListener("click", toggle);
      c.addEventListener("keydown", function(ev){
        if (ev.key === "Enter" || ev.key === " ") { ev.preventDefault(); toggle(); }
      });
      return c;
    }

    function renderGroups(){
      var wrap = $("[data-groups]"); wrap.innerHTML = "";
      var v = visibleItems();
      function sec(title, items){
        if (!items.length) return;
        wrap.appendChild(el("div","hb-grouptitle", esc(title)));
        items.forEach(function(it){ wrap.appendChild(card(it)); });
      }
      sec(DATA.groupLabels.rear,  v.primary.filter(function(i){ return i.mount.indexOf("rear") === 0; }));
      sec(DATA.groupLabels.side,  v.primary.filter(function(i){ return i.mount.indexOf("side") === 0; }));
      sec(DATA.groupLabels.under, v.primary.filter(function(i){ return i.mount === "under"; }));

      if (v.cross.length){
        var d = el("details","hb-more");
        if (v.cross.some(function(it){ return !!sel[it.id]; })) d.open = true;
        d.appendChild(el("summary", null, esc(DATA.crossLineLabel) + " (" + v.cross.length + ")"));
        var inner = el("div");
        v.cross.forEach(function(it){ inner.appendChild(card(it)); });
        d.appendChild(inner);
        wrap.appendChild(d);
      }
    }

    function renderStage(){
      var stage = $("[data-stage]");
      $$(".hb-layer:not(.hb-base)", stage).forEach(function(n){ n.remove(); });
      var layers = [];
      Object.keys(sel).forEach(function(id){
        var it = itemById(id); if (!it) return;
        (sel[id].sides || ["a"]).forEach(function(sd){
          var a = artFor(it, sd);
          if (a) layers.push({ src:a.src, off:a.off, flip:a.flip, axis:a.axis || 0, z: it.z || 5 });
        });
      });
      layers.sort(function(a,b){ return a.z - b.z; });
      layers.forEach(function(L){
        var d = el("div","hb-layer");
        d.style.zIndex = L.z;
        var tf = "translate("+((L.off[0]*0.2) + (L.axis||0))+"%,"+(L.off[1]*0.2)+"%)" + (L.flip ? " scaleX(-1)" : "");
        d.innerHTML = '<img src="'+L.src+'" alt="" loading="lazy" style="transform:'+tf+'">';
        stage.appendChild(d);
        requestAnimationFrame(function(){ d.classList.add("on"); });
      });
      var n = Object.keys(sel).length;
      $("[data-empty]").classList.toggle("hide", n > 0);
      var chips = $("[data-chips]"); chips.innerHTML = "";
      if (n) chips.appendChild(el("div","hb-chip", n + " attachment" + (n>1?"s":"")));
      if (hubMode === "no" && n) chips.appendChild(el("div","hb-chip warn","No HUB"));
    }

    function renderOcc(){
      var c = occupancy(null);
      var railMap = { left:["RAIL-L-U","RAIL-L-D"], right:["RAIL-R-U","RAIL-R-D"] };
      $$("[data-rail]").forEach(function(r){
        r.innerHTML = "";
        railMap[r.dataset.rail].forEach(function(id){
          var d = el("div","hb-cell" + (c[id] ? " filled" : ""), c[id] ? "&bull;" : (id.indexOf("-U") > -1 ? "up" : "low"));
          d.title = c[id] || "empty";
          r.appendChild(d);
        });
      });
      var rear = $("[data-rear]"); rear.innerHTML = "";
      ["U-L","U-R","L-L","L-R"].forEach(function(id){
        rear.appendChild(el("div","hb-cell" + (c[id] ? " filled" : ""), c[id] ? esc(c[id]) : ""));
      });
      var under = $("[data-under]");
      under.className = "hb-cell" + (c["UNDER"] ? " filled" : "");
      under.textContent = c["UNDER"] || "bin slot";
    }

    function renderSummary(){
      var li = $("[data-lineitems]"); li.innerHTML = "";
      var total = 0, count = 0;
      var hubSel = $("[data-hubvariant]");
      if (hubMode === "yes" && hubSel){
        var opt = hubSel.options[hubSel.selectedIndex];
        var hp = (opt && opt.dataset.price) ? parseInt(opt.dataset.price,10)
               : parseInt((hubSel.options[1] && hubSel.options[1].dataset.price) || 0, 10);
        total += hp;
        li.appendChild(el("div","hb-li","<span>HUB mount</span><span>"+money(hp)+"</span>"));
      }
      Object.keys(sel).forEach(function(id){
        var it = itemById(id); if (!it) return;
        var m = mountOf(it), sides = sel[id].sides || ["a"];
        var cv = chosenVariant(it);
        total += cv.price * sides.length; count += sides.length;
        var where = m.sides ? sides.map(function(sd){ return sd==="b" ? m.b : m.a; }).join(" + ").toLowerCase() : "";
        li.appendChild(el("div","hb-li",
          "<span>"+esc(it.title)+(hasVariants(it)?" &mdash; "+esc(cv.title):"")+(sides.length>1?" &times; 2":"")+(where?" <em>("+where+")</em>":"")+"</span><span>"+money(cv.price*sides.length)+"</span>"));
      });

      $("[data-total]").textContent = money(total);
      $("[data-bartotal]").textContent = money(total);
      var bc = $("[data-barcount]");
      bc.textContent = count ? (count + " attachment" + (count>1?"s":"") + (hubMode==="yes" ? " + HUB" : "")) : (bc.dataset.empty || "");

      var tb = $("[data-toolbar]"), tc = $("[data-toolcount]");
      if (tb) tb.style.display = count > 0 ? "flex" : "none";
      if (tc) tc.textContent = count + " selected";
      if (count === 0) disarmReset();

      var needVariant = hubMode === "yes" && hubSel && hubSel.options.length > 2 && !hubVariant;
      var ready = count > 0 && !needVariant;
      [$("[data-cta]"), $("[data-barcta]")].forEach(function(b){
        if (!b) return;
        b.disabled = !ready || busy;
        b.textContent = busy ? "Adding…"
          : !count ? (b.dataset.idle || "Add to cart")
          : needVariant ? (T.chooseModel || "Choose your cart model")
          : "Add " + (count + (hubMode==="yes"?1:0)) + " items — " + money(total);
      });

      var notice = $("[data-hubnotice]");
      if (notice) notice.style.display = (hubMode === "no" && count > 0) ? "flex" : "none";
      if (hubSel) hubSel.style.display = hubMode === "yes" ? "block" : "none";
      root.classList.toggle("hb-active", count > 0);
    }

    function selectedList(){
      return Object.keys(sel).map(function(id){
        var it = itemById(id);
        if (!it) return null;
        return { handle: it.handle, title: it.title, variantId: chosenVariant(it).id,
                 sides: (sel[id].sides || ["a"]).slice() };
      }).filter(Boolean);
    }

    /* Anything else on the page that wants to mirror the build listens for
       this instead of reaching into the closure. */
    function announce(){
      try {
        var list = selectedList();
        document.dispatchEvent(new CustomEvent("summit:hub-change", { bubbles:true, detail:{
          line: line,
          items: list,
          handles: list.map(function(x){ return x.handle; })
        }}));
      } catch(e){}
    }

    function renderAll(){
      renderLines(); renderGroups(); renderStage(); renderOcc(); renderSummary();
      syncBrowseLink(); measureTabs(); writeStore(); announce();
    }

    /* ---- clear all and start over ---------------------------------- */
    var resetArmed = false, resetTimer = null;
    function disarmReset(){
      var b = $("[data-reset]"), t = $("[data-resettext]");
      clearTimeout(resetTimer); resetArmed = false;
      if (b) b.classList.remove("armed");
      if (b && t) t.textContent = b.dataset.idle;
    }
    function clearBuilderCartLines(){
      return fetch("/cart.js", { headers:{ "Accept":"application/json" } })
        .then(function(r){ return r.json(); })
        .then(function(cart){
          var updates = {};
          (cart.items||[]).forEach(function(li){
            if (li.properties && li.properties._hub_build === BUILD_KEY) updates[li.key] = 0;
          });
          if (!Object.keys(updates).length) return null;
          return fetch("/cart/update.js", { method:"POST",
            headers:{"Content-Type":"application/json","Accept":"application/json"},
            body: JSON.stringify({ updates: updates }) });
        })
        .catch(function(){ return null; });
    }
    function doReset(){
      sel = {}; variantChoice = {}; hubMode = "yes"; hubVariant = "";
      var hs = $("[data-hubvariant]"); if (hs) hs.value = "";
      $$("[data-hubseg] button").forEach(function(b){ b.setAttribute("aria-pressed", String(b.dataset.hub === "yes")); });
      var err = $("[data-err]"); if (err){ err.style.display = "none"; err.textContent = ""; }
      disarmReset(); hideAlert();
      renderAll();
      clearStore();
      clearBuilderCartLines().then(function(res){
        if (res) document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles:true }));
      });
      var bar = $("[data-tabbar]");
      if (bar && bar.getBoundingClientRect().top < 0) bar.scrollIntoView({ behavior:"smooth", block:"start" });
    }

    /* The cart page has no builder section, so each line carries the piece
       of artwork it is responsible for. That way /cart can redraw the exact
       same picture from Liquid alone, with no second copy of the config. */
    function baseArt(){
      var img = $(".hb-base img");
      return img ? (img.getAttribute("src") || "") : "";
    }

    function desiredItems(){
      var out = [], base = { _hub_build: BUILD_KEY, _hub_line: line };
      var bg = baseArt();
      if (bg) base._hub_base = bg;
      if (hubMode === "yes"){
        var hs = $("[data-hubvariant]");
        var id = hubVariant || (hs && hs.options.length === 2 ? hs.options[1].value : "");
        if (id) out.push({ id: parseInt(id,10), quantity:1, properties: Object.assign({}, base) });
      }
      Object.keys(sel).forEach(function(k){
        var it = itemById(k); if (!it) return;
        var m = mountOf(it);
        (sel[k].sides || ["a"]).forEach(function(sd){
          var props = Object.assign({}, base);
          if (m.sides) props["Position"] = (sd === "b" ? m.b : m.a);
          var art = artFor(it, sd);
          if (art){
            props._hub_art = art.src;
            props._hub_off = ((art.off[0]*0.2) + (art.axis||0)) + "," + (art.off[1]*0.2);
            props._hub_z = String(it.z || 5);
            if (art.flip) props._hub_flip = "1";
          }
          out.push({ id: chosenVariant(it).id, quantity:1, properties: props });
        });
      });
      return out;
    }

    function addToCart(opts){
      var silent = !!(opts && opts.silent === true);
      if (busy) return Promise.resolve(false);
      busy = true; renderSummary();
      var err = $("[data-err]"); err.style.display = "none";
      var want = desiredItems();
      return clearBuilderCartLines()
        .then(function(){
          return fetch("/cart/add.js", { method:"POST",
            headers:{"Content-Type":"application/json","Accept":"application/json"},
            body: JSON.stringify({ items: want }) });
        })
        .then(function(r){
          if(!r.ok) return r.json().then(function(j){ throw new Error(j.description || j.message || "Could not add to cart"); });
          return r.json();
        })
        .then(function(){
          if (silent){
            busy = false;
            renderSummary();
            document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles:true }));
            return true;
          }
          window.location.href = "/cart";
          return true;
        })
        .catch(function(e){
          busy = false;
          if (!silent){
            err.textContent = e.message || "Something went wrong. Please try again.";
            err.style.display = "block";
          }
          renderSummary();
          return false;
        });
    }

    /* ---- boot ------------------------------------------------------ */
    function start(){
      var params = new URLSearchParams(window.location.search);
      var addParam = params.get("add");
      var stored = readStore();
      var pageLine = lineFromPath();
      var jump = false;

      if (stored){
        if (stored.hubMode) hubMode = stored.hubMode;
        if (stored.hubVariant){
          hubVariant = stored.hubVariant;
          var hs0 = $("[data-hubvariant]"); if (hs0) hs0.value = hubVariant;
        }
        $$("[data-hubseg] button").forEach(function(b){ b.setAttribute("aria-pressed", String(b.dataset.hub === hubMode)); });
        if (stored.line) line = stored.line;
        /* variant choices first — placeItem asks whether the chosen one is in stock */
        Object.keys(stored.variants || {}).forEach(function(h){
          var it = itemByHandle(h);
          if (it && hasVariants(it)) variantChoice[it.id] = String(stored.variants[h]);
        });
        applyItems(stored.items);
      }

      if (pageLine) line = pageLine;

      if (addParam){
        var wanted = {};
        addParam.split(",").forEach(function(h){ h = h.trim(); if (h) wanted[h] = []; });
        var res = applyItems(wanted);

        if (res.applied.length){
          jump = true;
          res.applied.forEach(function(it){ flashIds[it.id] = true; });
          var first = res.applied[0];
          if (first.lines && !first.lines[line]){
            var target = Object.keys(first.lines).filter(function(k){ return first.lines[k]; })[0];
            if (target) line = target;
          }
        }
        if (res.failed.length){
          jump = true;
          showAlert(res.failed.map(noRoomHtml).join('<div style="height:10px"></div>'));
        }
      }

      var hash = (window.location.hash || "").replace("#","");
      if (hash && hasLine(hash)) line = hash;
      if (hash && hash === root.dataset.anchor) jump = true;

      if (!stored && !addParam){
        fetch("/cart.js", { headers:{ "Accept":"application/json" } })
          .then(function(r){ return r.json(); })
          .then(function(cart){
            var mine = (cart.items||[]).filter(function(li){ return li.properties && li.properties._hub_build === BUILD_KEY; });
            var restore = {};
            mine.forEach(function(li){
              if (li.properties._hub_line && !pageLine) line = li.properties._hub_line;
              if (HUB_IDS[li.variant_id]){
                hubMode = "yes"; hubVariant = String(li.variant_id);
                var s = $("[data-hubvariant]"); if (s) s.value = hubVariant;
                $$("[data-hubseg] button").forEach(function(b){ b.setAttribute("aria-pressed", String(b.dataset.hub === "yes")); });
                return;
              }
              var match = DATA.items.filter(function(it){
                if (it.variantId === li.variant_id) return true;
                return hasVariants(it) && it.variants.some(function(vr){ return vr.id === li.variant_id; });
              })[0];
              if (!match) return;
              if (hasVariants(match)) variantChoice[match.id] = String(li.variant_id);
              var m = MOUNT[match.mount] || MOUNT.side_lower;
              var side = (li.properties.Position && m.b && li.properties.Position === m.b) ? "b" : "a";
              if (!restore[match.handle]) restore[match.handle] = [];
              if (restore[match.handle].indexOf(side) === -1) restore[match.handle].push(side);
            });
            applyItems(restore);
            renderAll();
          })
          .catch(function(){ renderAll(); });
        return;
      }

      renderAll();

      if (jump){
        setTimeout(function(){
          measureAll();
          var y = window.pageYOffset + root.getBoundingClientRect().top - topOffset - 8;
          window.scrollTo({ top: Math.max(0,y), behavior:"smooth" });
          setTimeout(function(){ flashIds = {}; }, 2200);
        }, 120);
      }
    }

    /* ---- wiring ---------------------------------------------------- */
    var linesEl = $("[data-lines]");
    if (linesEl) linesEl.addEventListener("click", function(e){
      var b = e.target.closest("button[data-line]"); if(!b) return;
      line = b.dataset.line; renderAll();
    });
    var seg = $("[data-hubseg]");
    if (seg) seg.addEventListener("click", function(e){
      var b = e.target.closest("button[data-hub]"); if(!b) return;
      hubMode = b.dataset.hub;
      $$("button[data-hub]", seg).forEach(function(x){ x.setAttribute("aria-pressed", String(x === b)); });
      renderAll();
    });
    var hv = $("[data-hubvariant]");
    if (hv) hv.addEventListener("change", function(e){ hubVariant = e.target.value; renderSummary(); writeStore(); });
    var ah = $("[data-addhub]");
    if (ah) ah.addEventListener("click", function(){
      hubMode = "yes";
      $$("button[data-hub]").forEach(function(x){ x.setAttribute("aria-pressed", String(x.dataset.hub === "yes")); });
      renderAll();
      var s = $("[data-hubvariant]"); if (s) s.focus();
    });
    var ac = $("[data-alertclose]"); if (ac) ac.addEventListener("click", hideAlert);
    var resetBtn = $("[data-reset]");
    if (resetBtn) resetBtn.addEventListener("click", function(){
      var t = $("[data-resettext]");
      if (!resetArmed){
        resetArmed = true;
        resetBtn.classList.add("armed");
        if (t) t.textContent = resetBtn.dataset.confirm;
        clearTimeout(resetTimer);
        resetTimer = setTimeout(disarmReset, 3500);
        return;
      }
      doReset();
    });
    [$("[data-cta]"), $("[data-barcta]")].forEach(function(b){ if(b) b.addEventListener("click", function(){ addToCart(); }); });

    /* Sticky + backdrop-filter is a combination WebKit will happily drop
       for a frame when it re-promotes the layer. Give the tab bar its own
       layer up front so the paint never blinks. */
    var tabBar = $("[data-tabbar]");
    if (tabBar){
      tabBar.style.transform = "translateZ(0)";
      tabBar.style.webkitBackfaceVisibility = "hidden";
      tabBar.style.backfaceVisibility = "hidden";
    }

    /* Measure at load, then again once late-arriving furniture (webfonts,
       announcement bars, app embeds) has settled. Never on scroll. */
    measureAll();
    [60, 300, 1200].forEach(function(ms){ setTimeout(measureAll, ms); });
    window.addEventListener("load", measureAll);
    if (document.fonts && document.fonts.ready && document.fonts.ready.then){
      document.fonts.ready.then(measureAll).catch(function(){});
    }

    var rz;
    window.addEventListener("resize", function(){
      clearTimeout(rz); rz = setTimeout(measureAll, 150);
    }, { passive:true });
    window.addEventListener("orientationchange", function(){ setTimeout(measureAll, 250); });

    if (window.ResizeObserver){
      var barEl = $("[data-tabbar]");
      if (barEl) new ResizeObserver(function(){ measureTabs(); }).observe(barEl);
      /* If the theme's own top furniture changes height (announcement bar
         dismissed, header shrinks on its own schedule), that is a real
         layout change and we do want to react — but it is driven by the
         element resizing, not by the scroll position. */
      new ResizeObserver(function(){ measureTop(); }).observe(document.documentElement);
    }

    /* Scroll does exactly two things now: toggle two classes. It writes no
       custom properties and reads no heights, so it cannot move layout.
       Both toggles use separate enter and exit thresholds — with a single
       threshold the stage resize moves the very rectangle being measured
       and the class chatters on and off around the boundary. */
    var ticking = false, shrunk = false, pinned = false;
    window.addEventListener("scroll", function(){
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        var r = root.getBoundingClientRect();

        if (!shrunk){
          if (r.top < -220 && r.bottom > 340) shrunk = true;
        } else {
          if (r.top > -60 || r.bottom < 240) shrunk = false;
        }
        root.classList.toggle("hb-shrunk", shrunk);

        var barEl2 = $("[data-tabbar]");
        if (barEl2){
          var t = barEl2.getBoundingClientRect().top;
          if (!pinned){
            if (t <= topOffset + 1 && r.bottom > 260) pinned = true;
          } else {
            if (t > topOffset + 8 || r.bottom < 180) pinned = false;
          }
          root.classList.toggle("hb-pinned", pinned);
        }
        ticking = false;
      });
    }, { passive:true });

    /* Public API. The attachment directory uses this instead of
       synthesising clicks on cards it does not own. */
    window.SummitHub = {
      line: function(){ return line; },
      has: function(h){ return !!itemByHandle(h); },
      isSelected: function(h){ var it = itemByHandle(h); return !!(it && sel[it.id]); },
      selected: function(){ return selectedList(); },
      handles: function(){ return selectedList().map(function(x){ return x.handle; }); },
      alertText: function(){
        var t = $("[data-alerttext]");
        return t ? t.textContent.trim() : "";
      },
      add: function(h){
        var it = itemByHandle(h);
        if (!it) return { ok:false, reason:"unknown" };
        if (sel[it.id]) return { ok:true, already:true, title: it.title };
        if (!chosenVariant(it).available) return { ok:false, reason:"soldout", title: it.title };
        if (it.lines && !it.lines[line]){
          var want = Object.keys(it.lines).filter(function(k){ return it.lines[k]; })[0];
          if (want) line = want;
        }
        if (!placeItem(it, [])){
          showAlert(noRoomHtml(it));
          renderAll();
          return { ok:false, reason:"noroom", title: it.title };
        }
        hideAlert();
        renderAll();
        return { ok:true, title: it.title };
      },
      remove: function(h){
        var it = itemByHandle(h);
        if (!it || !sel[it.id]) return false;
        delete sel[it.id];
        hideAlert();
        renderAll();
        return true;
      },
      syncCart: function(){ return addToCart({ silent:true }); },
      scrollTo: function(){
        var y = window.pageYOffset + root.getBoundingClientRect().top - topOffset - 12;
        window.scrollTo({ top: Math.max(0, y), behavior:"smooth" });
      },
      flash: function(h){
        var c = root.querySelector('.hb-card[data-handle="' + String(h).replace(/"/g,"") + '"]');
        if (c) c.classList.add("flash");
      },
      /* Debug helper: SummitHub.debugTop() in the console reports what the
         builder thinks the theme is parking at the top of the viewport. */
      debugTop: function(){ return { hbTop: topOffset, hbTabh: tabHeight, measuredNow: rawTop() }; }
    };

    renderLines();
    start();
  }

  function bootAll(scope){
    var roots = (scope || document).querySelectorAll("[data-hub-builder]");
    Array.prototype.slice.call(roots).forEach(boot);
  }

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", function(){ bootAll(); });
  } else {
    bootAll();
  }
  document.addEventListener("shopify:section:load", function(e){ bootAll(e.target); });
})();
